import React from 'react';
import { TouchableOpacity, View, Text, StyleSheet, Image, Platform, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import Images from '../../constants/Images';
// import { CurrencyFormat } from '../../components';
import ProjectLockOverlay from './ProjectLockOverlay';
import { useNavigation } from '@react-navigation/native';
import { Entypo, Ionicons, FontAwesome } from '@expo/vector-icons';
import { CachedImage } from '../../components';
import { LinearGradient } from 'expo-linear-gradient';
import { formatCurrency } from '../../utils/Functions';
import UserState from '../../src/contexts/UserState';
import * as Device from 'expo-device';
import { useLinkTo } from '@react-navigation/native';

export default function ProjectPreview({ ...props }) {
  const [user, setUser] = React.useContext(UserState);
  const navigation = useNavigation();
  const [isTablet, setIsTablet] = React.useState(false);
  const [isWeb, setIsWeb] = React.useState(Platform.OS === 'web');

  const isCompleted = (props.project.stage === 'Completed' && (props.showCompleted === undefined || !props.showCompleted)) ? true : false;
  const width = Dimensions.get('window').width;
  const screenWidth = Platform.OS === 'web' && width > 768 ? 768 : width;
  const linkTo = useLinkTo();

  React.useEffect(() => {
    (async () => {
      setIsTablet(await Device.getDeviceTypeAsync() === Device.DeviceType.TABLET ? true : false);
    })()
  }, []);

  const selectProject = (project) => {
    console.log('selectProject', project);
    linkTo(`/project/${project.id}`)
  }
  const defaultProjectImage = require('../../assets/img/default_project.jpg');
  const defaultProjectImageCompleted = require('../../assets/img/default_project_completed.jpg');

  const imageStyle = () => {
    if (Platform.OS === 'web'){
      const imgWidth = screenWidth >= 768 ? ((screenWidth - 30) / 2) : (screenWidth - 20);
      // console.log('imageStyle: ', screenWidth, imgWidth, imgWidth * 0.75);
      return {
        // width: 768,
        // height: 576,
        // width: '100%',
        width: imgWidth,
        // height: isCompleted ? 576 : 273
        height: imgWidth * 0.75,
      }
    }
    return {
      aspectRatio: Images.project.main.width / Images.project.main.height,
    }
  }

  const maxWidth = () => {
    if ((isTablet || isWeb) && width >= 768){
      return screenWidth / 2 - 20;
    }
    return 'auto'
  }

  // if(Platform.OS === 'web'){
  //   return(
  //     <View style={{ width: 200, height: 200, backgroundColor: 'pink' }}>
  //       <Text style={[CS.smallText, CS.lightText]}>{props.project.title}</Text>
  //     </View>
  //   )
  // }

  return (
    <TouchableOpacity onPress={() => selectProject(props.project)} activeOpacity={0.6} style={[styles.borderRadius, { overflow: 'hidden', flex: 1, marginHorizontal: (((isTablet || isWeb) && !isCompleted && width >= 768) ? 5 : 0), maxWidth: maxWidth() }]}>
      {!props.project.main_image &&
        <Image source={props.project.stage === 'Completed' ? defaultProjectImageCompleted : defaultProjectImage} style={[CS.responsiveImage, styles.borderRadius, imageStyle()]} />
      }
      {props.project.main_image &&
        <CachedImage source={{ uri: props.project.main_image }} style={[CS.responsiveImage, styles.borderRadius, imageStyle()]} />
      }
      <LinearGradient colors={['transparent', Colors.darkGrey]} style={styles.gradient} />
      {!isCompleted && 
      <View style={styles.stageOverlay}>
        <Text style={[CS.smallText, CS.darkText, CS.boldText]}>{props.project.stage || 'No stage'}</Text>
      </View>
      }
      <View style={styles.typeOverlay}>
        {props.project.homeowner_id === user.id && 
          <Ionicons name="home" size={24} color={Colors.transparentGrey3} />
        }
        {props.project.contractor_id === user.id &&
          <Ionicons name="construct" size={24} color={Colors.transparentGrey3} />
        }
      </View>
      <ProjectLockOverlay stage={props.project.stage} />
      <View style={styles.textOverlay}>
        <Text style={[CS.smallTitle, CS.yellowText, styles.title, (isCompleted && CS.whiteText)]}>{props.project.title || 'No title'}</Text>
        <View style={styles.locationAmount}>
          <View style={styles.locationName}>
            <View style={[styles.locationContainer, { marginBottom: 3 }]}>
              <Entypo name="location-pin" size={20} color={Colors.lightText} />
              <Text style={[CS.miniText, CS.lightText, styles.location]}>{props.project.address || 'No address'}</Text>
            </View>
            {props.project.full_name ?
              <View style={[styles.locationContainer, { marginLeft: 3 }]}>
                <FontAwesome name="user" size={20} color={Colors.lightText} />
                <Text style={[CS.miniText, CS.lightText, styles.location, { marginLeft: 8 }]}>{props.project.full_name}</Text>
              </View>
              : null}
          </View>
          <Text style={[CS.smallTitle, CS.lightText, styles.amount]}>{formatCurrency(props.project.amount)}</Text>
        </View>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
  },
  contractorName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.lightText,
  },
  defaultProjectImage: {
    aspectRatio: 339 / 158,
  },
  textOverlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    padding: 10,
    // backgroundColor: 'rgba(0,0,0,0.25)',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    justifyContent: 'flex-end',
  },
  locationAmount: {
    flexDirection: 'row',
    // alignItems: 'center',
    alignItems: 'flex-end',
    // backgroundColor: 'pink'
    // flex: 1,
  },
  locationName: {
    flex:1,
    marginRight: 10,
  },
  title: {
    marginTop: 0,
    marginBottom: 5,
  },
  amount: {
    // marginRight: 10,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 'auto',
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  location: {
    marginLeft: 5,
    flex: 1,
    flexWrap: 'wrap'
  },
  stageOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding:10,
    backgroundColor: Colors.yellow,
    borderBottomLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  typeOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: 10,
    // backgroundColor: Colors.transparentGrey2,
    backgroundColor: 'transparent',
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  // whiteBackground: {
  //   backgroundColor: Colors.white,
  // },
  borderRadius: {
    borderRadius: 10,
  },
  // iconContainer: {
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: '100%',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // // svg: {
  // //   position:'absolute',
  // // },
  // lockIcon: {
  //   position:'absolute',
  //   paddingTop: 10,
  // },
  gradient: {
    position: 'absolute',
    top:0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});